module.exports = __webpack_public_path__ + "article-7051a3ee/feedback-197cedee9db8213138f8094043dfb7c1.jpeg";